'use client';
import parse, { type HTMLReactParserOptions } from 'html-react-parser';
import Partials from 'components/partials/Partials';
import Link from 'components/UI/Link/Link';
import { useNoNav } from 'hooks/useNoNav';
import type { WidgetMenuProps } from 'types/menu';
import ScrollTopButton from './components/ScrollTopButton';
import styles from './Footer.module.scss';

const Footer = ({
  context,
  seoText,
  seoTitle,
  pageType,
}: {
  context?: Array<WidgetMenuProps>;
  seoTitle?: string;
  seoText?: string;
  pageType?: string;
}) => {
  const noNav = useNoNav();

  const parserOptions: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode.type === 'tag' && domNode.attribs) {
        const cleanAttribs: Record<string, string> = {};

        Object.keys(domNode.attribs).forEach((key) => {
          if (/^[a-zA-Z][a-zA-Z0-9-_:]*$/.test(key)) {
            cleanAttribs[key] = domNode.attribs[key];
          }
        });

        domNode.attribs = cleanAttribs;
      }
    },
  };

  if (noNav) return <></>;

  return (
    <footer className={styles.footer} data-testid="footer">
      <aside />
      <div className={styles.mainContentZone}>
        <div className={styles.inner}>
          {pageType !== 'article' && seoTitle && seoText && (
            <div className={styles.text}>
              {seoTitle && <h2 className={styles.seoTitle}>{seoTitle}</h2>}

              {seoText && <div>{parse(seoText, parserOptions)}</div>}
            </div>
          )}

          {context && context.length > 0 && <Partials context={context[0]} />}

          <div className={styles.homeLink}>
            <Link href="/">Home</Link>
            <ScrollTopButton />
          </div>

          <div>© {new Date().getFullYear()} RTL interactive GmbH</div>
        </div>
      </div>
      <aside />
    </footer>
  );
};

export default Footer;
